import React from 'react'

import { AppRetailerBlockContainer } from "@components/DataBlocks"
import { Typography } from "@mui/material"


export default function sitesColumn() {

	return [{
			name: 'sitesNameFilter',
			label: 'Sites',
			options: {
				display: 'excluded',
				filterType: 'textField',
				customBodyRowRender: value => <Typography>{value}</Typography>,
			}
		}, {
			name: 'sitesName',
			label: 'Sites',
			options: {
				headerAlign: 'left',
				filter: false,
				customBodyRowRenderLite: value => <AppRetailerBlockContainer rows={value}/>,
			}
		}]
}